"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.card = exports.shape = exports.borderRadius = void 0;
exports.borderRadius = {
    general: 8,
    fullyRounded: "9999px",
    input: "0.25rem",
    button: "3rem",
};
exports.shape = {
    borderRadius: exports.borderRadius.general,
};
exports.card = {
    borderRadius: exports.borderRadius.general,
};
//# sourceMappingURL=shape.js.map